import { DataBean } from "../DataBean";

export class QualityInspectionSample extends DataBean {

  public async getQualityInspectionSampleCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionSampleCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionSampleRender( page: number, rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionSampleRender_Number_Number_java.util.Map",
      [page,rows,properties]
    );
  }

  public async deleteQualityInspectionSample(idqualityinspectionsample: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionSample_Number", [idqualityinspectionsample]);
  }

  public async updateQualityInspectionSample(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionSample_updateQualityInspectionSample_com.orange.finance.processcontract.bean.QualityInspectionSample",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionSample",
        },
      ]
    );
  }
}
